import { Box } from "@chakra-ui/react";
import React from "react";
import { ProductFeatures } from "ui/product-features";
import { TextTitle } from "ui/text";
import { LottieWithStaticSafariImage } from "ui/lottie";
import productDiagram from "../../../../../public/assets/solutions/saas/diagram.png";
import firstMobileDiagram from "../../../../../public/assets/solutions/saas/mobile-diagram-1.png";
import secondMobileDiagram from "../../../../../public/assets/solutions/saas/mobile-diagram-2.png";
import thirdMobileDiagram from "../../../../../public/assets/solutions/saas/mobile-diagram-3.png";
import animationData from "./animation.json";

export function SaasDiagram() {
  return (
    <Box>
      <TextTitle
        align="center"
        size="lg"
        theme="dark"
        title="Personalize messages to prospects and leads across channels"
      />

      <ProductFeatures
        mt={{ base: "bigger", md: "huge" }}
        theme="dark"
        media={
          <LottieWithStaticSafariImage
            ratio={1320 / 553}
            animationData={animationData}
            containerProps={{ borderRadius: "bigger", overflow: "hidden" }}
            image={productDiagram}
            imagePlaceholder="blur"
            alt="Abstract illustration depicting three columns where data flows left to right. On the left the first column shows targeted accounts, users, and product data. The middle column shows data flowing into personalized audiences like lapsed customers, recent purchasers, and inactive customers. The right-most column shows data moving into cross channel journeys with actions that include target audience accounts on LinkedIn, update records for all customers in Salesforce, and send alerts in slack for churn risks."
          />
        }
        productFeatures={[
          {
            id: "feature-1",
            title: "Reach your prospects on ad platforms",
            description:
              "Target key accounts, suppress existing customers, and inform advertising platforms about conversions to reach new customers at efficient cost.",
            cta: {
              label: "How Hightouch supports advertising",
              href: "/solutions/advertising",
              variant: "primary",
              target: "_blank",
            },
            mobileImage: {
              src: firstMobileDiagram,
              alt: "A column with targeted accounts, users, and product data and data flowing out of it to the right.",
            },
          },
          {
            id: "feature-2",
            title: "Personalize marketing automation",
            description:
              "Use your data to personalize messages to your customers in email, SMS, in-app messages, and more.",
            cta: {
              label: "How Hightouch supports marketing",
              href: "/solutions/marketing",
              variant: "primary",
              target: "_blank",
            },
            mobileImage: {
              src: secondMobileDiagram,
              alt: "A column with data flowing into personalized audiences like lapsed customers, recent purchasers, and inactive customers.",
            },
          },
          {
            id: "feature-3",
            title: "Build cross-channel journeys",
            description:
              "Use all of your customer, product-usage, and account data to curate the perfect journeys that engage prospects and customers.",
            cta: {
              label: "See Journeys in action",
              href: "/platform/customer-studio#journeys",
              variant: "primary",
              target: "_blank",
            },
            mobileImage: {
              src: thirdMobileDiagram,
              alt: "A column with data moving into cross channel journeys with actions that include target audience accounts on LinkedIn, update records for all customers in Salesforce, and send alerts in slack for churn risks.",
            },
          },
        ]}
      />
    </Box>
  );
}
